<template>
  <div class="home-container">
    <div class="home-content">
      <div style="margin: 20px">
        <el-button
          size="small"
          plain
          type="primary"
          icon="el-icon-plus"
          @click="addCharacter"
          style="width: 90px"
          >新增</el-button
        >
      </div>

      <el-table
        border
        :data="tableData"
        v-loading="isShowloading"
        style="width: 100%"
      >
        <el-table-column prop="name" label="分类名称" align="center">
        </el-table-column>
        <el-table-column prop="isAdmin" label="是否管理员" align="center" :formatter="isAdminstatus">
        </el-table-column>
        <el-table-column prop="isPatrol" label="是否巡更人员" align="center" :formatter="isPatrolstatus">
        </el-table-column>
        <el-table-column prop="updateTime" label="创建时间" align="center">
        </el-table-column>                             
        <el-table-column fixed="right" align="center" label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="updataCharacter(scope.row)"
              >修改</el-button
            >

            <el-button @click="del(scope.row)" type="text" size="small"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <div class="block" style="margin-top: 15px">
        <el-pagination
          align="center"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
      <!-- 新增模态框 -->
      <el-dialog :title="modalTitle" :visible.sync="isAddModal" width="40%">
        <el-form
          ref="form"
          :model="addData"
          label-width="90px"
          :rules="addDataRules"
          label-position="center"
        >  
           <el-row>
            <el-col :span="12">
              <el-form-item label="分类名称" prop="name">
                <el-input
                placeholder="请输入分类名称"
                v-model="addData.name"
                clearable
                ></el-input>
              </el-form-item>
            </el-col>          
          </el-row>  
          <el-row>
            <el-col :span="24">
              <el-form-item label="小程序模板类型" prop="appletTemplateType" label-width="120px">
                <el-select
                  v-model="addData.appletTemplateType"
                  multiple
                  clearable filterable
                  placeholder="请选择"
                  style="width:100%"
                >
                  <el-option
                    v-for="item in appletList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>    
          <el-row>
            <el-col :span="24">
              <el-form-item label="是否管理员" prop="isAdmin" label-width="120px">
                <el-select
                  clearable filterable
                  v-model="addData.isAdmin"
                  placeholder="请选择"
                  style="width:100%"
                >
                  <el-option
                    v-for="item in isAdminList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>     
          <el-row>
            <el-col :span="24">
              <el-form-item label="是否巡更人员" prop="isPatrol" label-width="120px">
                <el-select
                  clearable filterable
                  v-model="addData.isPatrol"
                  placeholder="请选择"
                  style="width:100%"
                >
                  <el-option
                    v-for="item in isPatrolList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>                       
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="isAddModal = false">取 消</el-button>
          <el-button type="primary" @click="submit" :loading="btnLoading"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      modalTitle: "新增",
      tableData: [],
      currentPage: 1, // 当前页码
      total: 20, // 总条数
      pageSize: 10, // 每页的数据条数
      addData: {
        id: "",
        name:''
      },
      addDataRules: {
        name: [{ required: true, message: "请分类名称", trigger: "blur" }]
      },
      isShowloading: false, //数据加载
      isAddModal: false, //新增模态框
      btnLoading: false, //提交按钮加载
      appletList:[
        {
          id:"1",
          name:'工单创建'
        },
        {
          id:"2",
          name:'工单分发'
        },
        {
          id:"3",
          name:'工单完成'
        },
        {
          id:"4",
          name:'投诉意见'
        }
      ],
      isAdminList:[
        {
          id:1,
          name:'是'
        },{
          id:-1,
          name:'否'
        },
      ] ,
      isPatrolList:[
        {
          id:1,
          name:'是'
        },{
          id:-1,
          name:'否'
        },
      ]       
    };
  },
  created() {},
  mounted() {
    this.onLoad();
  },
  methods: {
    isPatrolstatus(row){
      if(row.isPatrol == 1){
        return '是'
      }else{
        return "否"
      }
    },
    isAdminstatus(row){
      if(row.isAdmin == 1){
        return '是'
      }else{
        return "否"
      }
    },
    // 新增角色
    addCharacter() {
      for (let item in this.addData) {
        this.addData[item] = "";
      }
      this.modalTitle = "新增"; 
      this.isAddModal = true;
    },
    // 修改
    updataCharacter(row) {
      this.addData = JSON.parse(JSON.stringify(row));
      this.addData.appletTemplateType = row.appletTemplateType ? row.appletTemplateType.split(',') : []
      this.isAddModal = true;
    },
    //删除
    del(row) {
      let id = row.id;
      this.$confirm("您确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$Apis.manageTypeDel({ id }).then((res) => {
          if (res.code == 200) {
            this.onLoad();
            this.$message.success("删除成功");
          } else {
            this.$message.warning(res.msg);
          }
        });
      });
    },
    submit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          var data = {
            id: this.addData.id || "",
            name: this.addData.name,
            isAdmin:this.addData.isAdmin,
            isPatrol:this.addData.isPatrol,
            appletTemplateType:this.addData.appletTemplateType.join(',')
          };
          this.$Apis.manageTypeAddUp(data).then((res) => {
            this.btnLoading = false;
            this.isAddModal = false;
            if (res.code == 200) {
              this.onLoad();
              this.$message.success("操作成功");
            } else {
              this.$message.warning(res.msg);
            }
          });
        }
      });
    },

    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.onLoad()
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.onLoad()
    },
    onLoad() {
      this.isShowloading = true;
      let page = {
        size: this.pageSize,
        current: this.currentPage
      };
      this.$Apis.manageTypeList(page).then((res) => {
        this.isShowloading = false;
        if (res.code == 200) {
          let { current, list, pages, total } = res.data;
          this.currentPage = current;
          this.size = pages;
          this.total = total;
          this.tableData = list;
        }
      });
    },
  },
};
</script>

<style>
.home-container {
  padding: 10px;
  padding-top: 5px;
}
.home-content {
  padding: 10px;
  border-radius: 5px;
  background: #fff;
}
.tree {
  margin-top: 10px;
  width: 300px;
  z-index: 999;
  background-color: #fff;
  padding: 20px;
  height: 200px;
  overflow: auto;
  border: 1px solid #eee;
  border-radius: 5px;
}
.actice .el-upload--picture-card {
  display: none !important;
}
</style>